module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "datagrid list-group"
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.articleList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "datagrid-item list-group-item"
    }, [_c('a', {
      staticClass: "item__box",
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.onItemClick(item)
        }
      }
    }, [_c('span', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.copyright))]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.auditDate))])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5a1c5f94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/combo/datagrid.vue
// module id = 605
// module chunks = 1